import {Box} from '@mui/material';
import {AurInfographicProps} from './types';
import styles from './style.module.scss';
import AurInfographicCell from './AurInfographicCell';
import AurInfographicSeperator from './AurInfographicSeperator';

const AurInfographic = ({
  cellConfigs,
  className,
  testId = '',
}: AurInfographicProps) => {
  const cellCount = cellConfigs.length;
  return (
    <Box
      className={`${styles.aurInfographicContainer} ${className}`}
      data-testid={testId}
    >
      {cellConfigs.map((cell, index) => {
        return (
          <>
            <AurInfographicCell {...cell} key={`cell-${index}`} />
            {index === cellCount - 1 || !cell.seperator ? (
              ''
            ) : (
              <AurInfographicSeperator
                key={`seperator-${index}`}
                seperatorIcon={cell.seperator}
              />
            )}
          </>
        );
      })}
    </Box>
  );
};

export default AurInfographic;
